function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Tabs, message, Skeleton, Button, Space, Form, Drawer, DatePicker, Statistic, Divider, Tag, Input, notification } from 'antd';
import { Table } from 'react-bootstrap';
import { Eyedropper, ClipboardHeartFill, PersonBoundingBox, ImageFill, ShareFill, Broadcast, FileBreak, MagnetFill, BookmarksFill, Clipboard2PulseFill } from "react-bootstrap-icons";
import Common from "../components/includes/Common";
import Moment from 'react-moment';
import DepartmentQueueDisplay from "../components/DepartmentQueueDisplay";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;

var Attendance = function Attendance() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showQueue = _useState2[0],
      setShowQueue = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedDcode = _useState4[0],
      setSelectedDcode = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      longName = _useState6[0],
      setLongName = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      labCount = _useState8[0],
      setLabCount = _useState8[1];

  var _useState9 = useState(0),
      _useState10 = _slicedToArray(_useState9, 2),
      cardioCount = _useState10[0],
      setCardioCount = _useState10[1];

  var _useState11 = useState(0),
      _useState12 = _slicedToArray(_useState11, 2),
      radioCount = _useState12[0],
      setRadioCount = _useState12[1];

  var _useState13 = useState(0),
      _useState14 = _slicedToArray(_useState13, 2),
      scanCount = _useState14[0],
      setScanCount = _useState14[1];

  var _useState15 = useState(0),
      _useState16 = _slicedToArray(_useState15, 2),
      irmCount = _useState16[0],
      setIrmCount = _useState16[1];

  var _useState17 = useState(0),
      _useState18 = _slicedToArray(_useState17, 2),
      echoCount = _useState18[0],
      setEchoCount = _useState18[1];

  var _useState19 = useState(0),
      _useState20 = _slicedToArray(_useState19, 2),
      mammoCount = _useState20[0],
      setMammoCount = _useState20[1];

  var _useState21 = useState(0),
      _useState22 = _slicedToArray(_useState21, 2),
      dentalCount = _useState22[0],
      setDentalCount = _useState22[1];

  var _useState23 = useState(0),
      _useState24 = _slicedToArray(_useState23, 2),
      checkCount = _useState24[0],
      setCheckCount = _useState24[1];

  var _useState25 = useState(false),
      _useState26 = _slicedToArray(_useState25, 2),
      dataChanged = _useState26[0],
      setDataChanged = _useState26[1];

  var _useState27 = useState(""),
      _useState28 = _slicedToArray(_useState27, 2),
      loadError = _useState28[0],
      setLoadError = _useState28[1];

  var handleDepView = function handleDepView(dc, ln) {
    setSelectedDcode(dc);
    setLongName(ln);
    setShowQueue(true);
  };

  useEffect(function () {
    setDataChanged(false);
    setLoadError("");
    axios.get(Common.baseApiUrl + "getdailyqueuecounts/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setLabCount(response.data.labCount);
        setCardioCount(response.data.cardioCount);
        setRadioCount(response.data.radioCount);
        setIrmCount(response.data.irmCount);
        setScanCount(response.data.scanCount);
        setEchoCount(response.data.echoCount);
        setMammoCount(response.data.mammoCount);
        setDentalCount(response.data.dentalCount);
        setCheckCount(response.data.checkCount);
      } else {
        setLoadError(response.data.message);
      }
    })["catch"](function (error) {
      setLoadError("Une erreur est survenue " + error.toString());
    })["finally"](function () {});
  }, [dataChanged]);
  useEffect(function () {
    setInterval(function () {
      setDataChanged(true);
    }, 30000);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 6,
          children: /*#__PURE__*/_jsxs("div", {
            className: "digitBox",
            style: {
              background: "#E1E1CD"
            },
            children: [/*#__PURE__*/_jsx("h3", {
              children: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(Clipboard2PulseFill, {
                  size: 40
                })
              })
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Statistic, {
              title: "Consultations",
              value: checkCount
            }), /*#__PURE__*/_jsx(Button, {
              onClick: function onClick() {
                handleDepView("CON", "Consultations");
              },
              style: {
                marginTop: 16
              },
              type: "default",
              children: /*#__PURE__*/_jsx("b", {
                children: "Voir"
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 6,
          children: /*#__PURE__*/_jsxs("div", {
            className: "digitBox",
            children: [/*#__PURE__*/_jsx("h3", {
              children: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(Eyedropper, {
                  size: 40
                })
              })
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Statistic, {
              title: "Laboratoire",
              value: labCount
            }), /*#__PURE__*/_jsx(Button, {
              onClick: function onClick() {
                handleDepView("LAB", "Laboratoire");
              },
              style: {
                marginTop: 16
              },
              type: "default",
              children: /*#__PURE__*/_jsx("b", {
                children: "Voir"
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 6,
          children: /*#__PURE__*/_jsxs("div", {
            className: "digitBox",
            style: {
              background: "#CDDDE1"
            },
            children: [/*#__PURE__*/_jsx("h3", {
              children: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(ImageFill, {
                  size: 40
                })
              })
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Statistic, {
              title: "Echographie",
              value: echoCount
            }), /*#__PURE__*/_jsx(Button, {
              onClick: function onClick() {
                handleDepView("ECH", "Echographie");
              },
              style: {
                marginTop: 16
              },
              type: "default",
              children: /*#__PURE__*/_jsx("b", {
                children: "Voir"
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 6,
          children: /*#__PURE__*/_jsxs("div", {
            className: "digitBox",
            style: {
              background: "#E1CECD"
            },
            children: [/*#__PURE__*/_jsx("h3", {
              children: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(Broadcast, {
                  size: 40
                })
              })
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Statistic, {
              title: "Radiologie",
              value: radioCount
            }), /*#__PURE__*/_jsx(Button, {
              onClick: function onClick() {
                handleDepView("RAD", "Radiologie");
              },
              style: {
                marginTop: 16
              },
              type: "default",
              children: /*#__PURE__*/_jsx("b", {
                children: "Voir"
              })
            })]
          })
        })]
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 6,
          children: /*#__PURE__*/_jsxs("div", {
            className: "digitBox",
            style: {
              background: "#D9CDE1"
            },
            children: [/*#__PURE__*/_jsx("h3", {
              children: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(FileBreak, {
                  size: 40
                })
              })
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Statistic, {
              title: "Scanner",
              value: scanCount
            }), /*#__PURE__*/_jsx(Button, {
              onClick: function onClick() {
                handleDepView("SCA", "Scanner");
              },
              style: {
                marginTop: 16
              },
              type: "default",
              children: /*#__PURE__*/_jsx("b", {
                children: "Voir"
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 6,
          children: /*#__PURE__*/_jsxs("div", {
            className: "digitBox",
            style: {
              background: "#E1CDD0"
            },
            children: [/*#__PURE__*/_jsx("h3", {
              children: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(MagnetFill, {
                  size: 40
                })
              })
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Statistic, {
              title: "IRM",
              value: irmCount
            }), /*#__PURE__*/_jsx(Button, {
              onClick: function onClick() {
                handleDepView("IRM", "IRM");
              },
              style: {
                marginTop: 16
              },
              type: "default",
              children: /*#__PURE__*/_jsx("b", {
                children: "Voir"
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 6,
          children: /*#__PURE__*/_jsxs("div", {
            className: "digitBox",
            style: {
              background: "#CDD5E1"
            },
            children: [/*#__PURE__*/_jsx("h3", {
              children: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(PersonBoundingBox, {
                  size: 40
                })
              })
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Statistic, {
              title: "Mammographie",
              value: mammoCount
            }), /*#__PURE__*/_jsx(Button, {
              onClick: function onClick() {
                handleDepView("MAM", "Mammographie");
              },
              style: {
                marginTop: 16
              },
              type: "default",
              children: /*#__PURE__*/_jsx("b", {
                children: "Voir"
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 6,
          children: /*#__PURE__*/_jsxs("div", {
            className: "digitBox",
            style: {
              background: "#E1E1CD"
            },
            children: [/*#__PURE__*/_jsx("h3", {
              children: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(ClipboardHeartFill, {
                  size: 40
                })
              })
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Statistic, {
              title: "Cardiologie",
              value: cardioCount
            }), /*#__PURE__*/_jsx(Button, {
              onClick: function onClick() {
                handleDepView("CAR", "Cardiologie");
              },
              style: {
                marginTop: 16
              },
              type: "default",
              children: /*#__PURE__*/_jsx("b", {
                children: "Voir"
              })
            })]
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(Drawer, {
      open: showQueue,
      title: longName,
      width: "90%",
      destroyOnClose: true,
      onClose: function onClose() {
        setShowQueue(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(DepartmentQueueDisplay, {
        dcode: selectedDcode,
        longName: longName
      })
    })]
  });
};

export default Attendance;